import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import * as actions from '../../actions/index';

function Layout ({ showSidebarCollapse, showSidebar, sidebarCollapse, sidebarShow }) {
  const changeSidebarVisibility = () => {
    showSidebarCollapse(!sidebarCollapse);
  };

  const changeMobileSidebarVisibility = () => {
    showSidebar(!sidebarShow);
  };


  const layoutClass = classNames({
    layout: true,
    'layout--collapse': sidebarCollapse
  });

  return (
    <div className={layoutClass}>
      <Navbar
        changeMobileSidebarVisibility={changeMobileSidebarVisibility}
        changeSidebarVisibility={changeSidebarVisibility}
      />
      <Sidebar
        sidebarShow={sidebarShow}
        sidebarCollapse={sidebarCollapse}
        changeMobileSidebarVisibility={changeMobileSidebarVisibility}
      />
    </div>
  );
  
}
function mapStateToProps({ sidebar }) {
  const { sidebarShow, sidebarCollapse } = sidebar;
  return {
    sidebarShow,
    sidebarCollapse
  };
}

export default connect(mapStateToProps, actions)(Layout);
